// covered-by: frontends/carrie/src/ask-v2/pages/__tests__/AskV2ProjectPage.test.tsx
import { X } from "@phosphor-icons/react";
import { type ReactNode } from "react";
import { useTranslation } from "react-i18next";

export function AskV2OpenItemsSplit({
  onClose,
  children,
}: {
  onClose: () => void;
  children: ReactNode;
}) {
  const { t } = useTranslation("ui");
  return (
    <>
      {/* why: h-12 is PANE_HEADER_HEIGHT_CLASS; ask-v2 cannot import the V1 module that exports it */}
      <header
        data-testid="ask-v2-open-items-split-header"
        className="flex h-12 shrink-0 items-center justify-between gap-3 border-b border-puntt-neutral-gray-5 px-3"
      >
        <h2
          data-testid="ask-v2-open-items-split-title"
          className="min-w-0 truncate text-[15px] font-medium text-puntt-neutral-gray-12"
        >
          {t("askV2.openItems.listName")}
        </h2>
        <button
          type="button"
          data-testid="ask-v2-open-items-split-close"
          aria-label={t("askV2.openItems.close")}
          onClick={onClose}
          className="focus-visible:outline-puntt-brand-purple-9 shrink-0 rounded-md p-1 text-puntt-neutral-gray-11 hover:bg-puntt-neutral-gray-3 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
        >
          <X size={16} aria-hidden="true" />
        </button>
      </header>
      <div className="min-h-0 flex-1 overflow-y-auto p-3 [scrollbar-width:thin]">
        {children}
      </div>
    </>
  );
}
